import { createSlice } from '@reduxjs/toolkit';
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,

  proveedores: [],
  servicesProviders: null,
  paqueteriaSelected: {},
  listaPaqServiceUtility: [],

  // lista de proveedores publico
  proveedoresPublico: []
};

const slice = createSlice({
  name: 'dagpacketControlPaq',
  initialState,
  reducers: {
    getProveedoresPublicAction(state, action) {
      const data = action.payload;
      state.proveedoresPublico = data;
    },

    getProveedoresAction(state, action) {
      const data = action.payload;
      state.proveedores = data;
    },

    getPaqueteriaSelectedAction(state, action) {
      const data = action.payload;

      state.paqueteriaSelected = data;
    },

    getServicesProviders(state, action) {
      const data = action.payload;

      state.servicesProviders = data;
    },

    getPaqServiceUtilityList(state, action) {
      const data = action.payload;

      state.listaPaqServiceUtility = data;
    },

    updateUtilityAction(state, action) {
      const { utility, idPaq, idProvider } = action.payload;

      const provSelected = state.proveedores.find((prov) => prov.id === idProvider);
      const paqSelected = provSelected.rate_providers.find((paq) => paq.id === idPaq);
      paqSelected.utility = utility;
    },

    updatePaqStatusAction(state, action) {
      const { active, idPaq, idProvider } = action.payload;

      const provSelected = state.proveedores.find((prov) => prov.id === idProvider);
      const paqSelected = provSelected.rate_providers.find((paq) => paq.id === idPaq);
      paqSelected.active = active;
    },

    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

export const {
  getProveedoresAction,
  getPaqueteriaSelectedAction,
  updateUtilityAction,
  updatePaqStatusAction,
  getProveedoresPublicAction,
  getServicesProviders,
  getPaqServiceUtilityList
} = slice.actions;

// ----------------------------------------------------------------------

// export const selectItemAction = (item) => (dispatch) => {
//   console.log('action', item);
//   // dispatch(selectItemAction(item));
// };

// ----------------------------------------------------------------------
